         import { createTheme, ThemeProvider } from '@mui/material';
import './App.css';
import Pageroutes from './routes/Pageroutes';


function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#BB081B",
      },
      secondary: {
        main: '#E1AD1A',
        cart: '#FFA200'
      }
    },
    typography: {
      fontFamily: "Lato",     
      h1: {
        fontSize: '60px',
        fontWeight: 600,
        color: '#fff',
         fontFamily: "Lato",
       
      },
      h2: {
        fontSize: '30px',
        fontWeight: 400, fontFamily: "Lato",
        
      },
      h3: {
        fontSize: '24px',
        fontWeight: 400, fontFamily: "Lato",
     
      },
      h4: {
        fontSize: '18px',
        fontWeight: 400, fontFamily: "Lato",
      },
      h5: {
        fontSize: '16px',
        fontWeight: 400, fontFamily: "Lato",
      },
      h6: {
        fontSize: '15px',
        fontWeight: 400,
         fontFamily: "Lato",
      },
      body1: {
        fontSize: '16px',
        fontWeight: 400,
         fontFamily: "Lato",
      },
      body2: {
        fontSize: '12px',
        fontWeight: 400,
         fontFamily: "Lato",
      }
    }
  })

  // const location = useLocation()
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <Pageroutes />
    </ThemeProvider>
  );
}

export default App;
